import Skeleton from 'react-loading-skeleton'

export function PostalCodeSkeleton({
  width = 140,
  height = 32,
  baseColor = '#D9DDE1',
}) {
  return <Skeleton width={width} height={height} baseColor={baseColor} />
}
